import ky, { Options } from 'ky';
import Cookies from 'js-cookie';
import { KyInstance } from 'ky/distribution/types/ky.d';
import { message } from 'antd';

const config = {
  prefixUrl: MOCK_SERVER ? '' : process.env.REACT_APP_DSERS_HOST,
};

class HttpService {
  http: KyInstance;

  constructor(options: Options) {
    this.http = ky.create(options).extend({
      hooks: {
        beforeRequest: [
          (request) => {
            //如果是本地环境的话 通用的调试方案
            if (window.location.href.includes('localhost')) {
              request.headers.set(
                'Authorization',
                'Bearer 2c7376d644254e31a0c187e7e04e2ee5coj5kkqtjehgr414j6n0'
              );
            } else {
              request.headers.set('Authorization', `Bearer ${Cookies.get('session_id')}`);
            }
          },
        ],
        afterResponse: [
          async (_request, _options, response) => {
            // console.log(_request, _options, response);
            if (response.status === 400 || response.status === 500) {
              return new Response(response.body, { status: 200 });
            }
          },
          async (_request, _options, response) => {
            if (response.status === 200) {
              const responseBody = await response.json();
              // console.log(responseBody, 'responseBody');
              if (responseBody.reason && responseBody.reason === 'TEAM_DISABLE') {
                window.EVENT.emit('DISABLE_MODAL_OPEN');
              }
              if (responseBody.reason && responseBody.reason.includes('INVALID_TOKEN')) {
                if (window.location.href.includes('localhost')) {
                  message.error('INVALID_TOKEN ');
                  return;
                }
                window.location.href = `${
                  process.env.REACT_APP_DSERS_USER_CENTER_HOST
                }login?redirect_url=${encodeURIComponent(
                  `${window.location.origin}/management/`
                )}` as string;
              }
            }
          },
        ],
      },
    });
  }
}

export const Http = new HttpService(config).http;
